import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";
import ISOPercentage from "components/formatting/ISOPercentage";

export interface PercentOptions {
  headerLabels?: Record<string, string>;
}

/**
 *  Display the number as a percent.
 */
function percentColumn(options?: PercentOptions): GridColTypeDef {
  const percentColumn: GridColTypeDef = {
    ...baseColumn,
    type: "custom",
    align: "right",
    renderCell: (params: GridRenderCellParams) => {
      return <ISOPercentage value={params.value} />;
    }
  };
  if (options?.headerLabels) {
    percentColumn.renderHeader = fieldLabelFormat(options.headerLabels);
  }
  return percentColumn;
}

export default percentColumn;
